<template>
    <div class="space-y-4">
        <UFormGroup label="Title" required>
            <UInput
                :model-value="modelValue?.title ?? ''"
                @update:model-value="patch({ title: $event })"
                size="xl"
            />
        </UFormGroup>
        <UFormGroup label="Body" required>
            <UTextarea
                :model-value="modelValue?.body ?? ''"
                @update:model-value="patch({ body: $event })"
                :rows="4"
                autoresize
            />
        </UFormGroup>
        <UFormGroup label="Deep Link">
            <UInput
                :model-value="modelValue?.deep_link ?? ''"
                @update:model-value="patch({ deep_link: $event || undefined })"
                placeholder="e.g. samu://calls/join/..."
                size="xl"
            />
        </UFormGroup>
        <p class="text-xs text-gray-400">
            Merge tags: &#123;&#123;first_name&#125;&#125;, &#123;&#123;last_name&#125;&#125;, &#123;&#123;full_name&#125;&#125;, &#123;&#123;policy_holder&#125;&#125;
        </p>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{ modelValue: any }>()
const emit = defineEmits<{ 'update:modelValue': [any] }>()

function patch(partial: Record<string, any>) {
    emit('update:modelValue', { ...(props.modelValue ?? {}), ...partial })
}
</script>
